module.exports = __webpack_public_path__ + "img/file.ceb138a.svg";